// extracted by mini-css-extract-plugin
export default {"info_box":"index_info_box_2AOGe clearfix","comment":"index_comment_L5rKl","pic":"index_pic_S7pix","v_logo":"index_v_logo_qjo-e","text":"index_text_qHg3E","time":"index_time_z8dki"};